import React from 'react';
import styles from './spinner.module.scss';

const Spinner: React.FC = () => {
  return <div className={styles.spinner}></div>;
};

export default Spinner;
